module.exports = __webpack_public_path__ + "static/img/11.77a8bfec.png";